let anchorToScrollTo = null;
window.addEventListener("DOMContentLoaded", event => {
  anchorToScrollTo = document.querySelector('.variants-swatches-container') || document.querySelector('.product-form__buttons');
  const stickyAddToCartButton = document.querySelector('#button-sticky__with-variants');
  const productFormSubmit = document.querySelector('.product-form__submit');
  console.log(stickyAddToCartButton);
  console.log(productFormSubmit);
  if (stickyAddToCartButton != null) {
    stickyAddToCartButton.addEventListener('click', function () {
      if (document.querySelector('.variant-bundle__alert')) {
        const targetPosition = anchorToScrollTo.offsetTop - 150;
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
        const onScrollEnd = () => {
          if (Math.abs(window.scrollY - targetPosition) < 1) {
            productFormSubmit.click();
            window.removeEventListener('scroll', onScrollEnd);
          }
        };
        window.addEventListener('scroll', onScrollEnd);
      } else {
        stickyAddToCartButton.classList.toggle('button-sticky__with-variants--is-clicked');
        document.querySelector('.product-form__submit').click();
      }
    });
  }
  if (document.querySelector('#button-sticky__with-variants') != null && document.querySelector('.variant-bundle__alert')) {
    document.querySelector('#button-sticky__with-variants').addEventListener('click', function () {
      window.scrollTo(window.scrollX, anchorToScrollTo.offsetTop - 150);
    });
  }
});
window.addEventListener('scroll', function (e) {
  const stickyBanner = document.querySelector('.sticky-atc-banner');
  const footer = document.getElementsByTagName('footer')[0];
  if (stickyBanner && anchorToScrollTo && footer) {
    const positionAboveAnchor = window.pageYOffset + stickyBanner.offsetHeight < anchorToScrollTo.offsetTop;
    const bannerTouchesFooter = stickyBanner.offsetTop + stickyBanner.offsetHeight >= footer.offsetTop - window.pageYOffset;
    if (positionAboveAnchor || bannerTouchesFooter) {
      stickyBanner.classList.add('hideStickyAddtocart');
    } else {
      stickyBanner.classList.remove('hideStickyAddtocart');
    }
  }
});
function elementInViewportCustom(el) {
  var top = el.offsetTop;
  var height = el.offsetHeight;
  while (el.offsetParent) {
    el = el.offsetParent;
    top += el.offsetTop;
  }
  return top < window.pageYOffset + window.innerHeight && top + height > window.pageYOffset;
}